import { DefaultOptionType } from 'antd/es/select';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { ContractItemPriceRaiseStatus, PriceRaiseEligibleStatusFilter } from 'entities/Contract';
import { FC, memo, useCallback, useMemo } from 'react';
import { Select } from 'shared/ui/Select';
import { PriceRaiseListFilterKeys } from '../../model/types';

interface PriceRaiseStatusSelectProps {
  value?: string;
  mode: 'unprocessed' | 'processed';
  onChange: (value: string, label: string) => void;
  onClear: (filterKey: string) => void;
}

export const PriceRaiseStatusSelect: FC<PriceRaiseStatusSelectProps> = memo((props) => {
  const { value, mode, onChange, onClear } = props;

  const { t } = useAppTranslation('contracts');

  const statusOptions = useMemo<Array<{ label: string; value: string }>>(() => {
    if (mode === 'unprocessed') {
      return [
        { label: t('Review again'), value: PriceRaiseEligibleStatusFilter.REVIEW_AGAIN },
        { label: t('Already had a price raise'), value: PriceRaiseEligibleStatusFilter.HAD_COMPLETED },
      ];
    }

    return [
      { label: t('Accepted'), value: ContractItemPriceRaiseStatus.ACCEPTED },
      { label: t('Rejected'), value: ContractItemPriceRaiseStatus.REJECTED },
    ];
  }, [mode, t]);

  const handleChange = useCallback(
    (selectedValue: string, option?: DefaultOptionType | DefaultOptionType[]): void => {
      if (!Array.isArray(option) && typeof option?.label === 'string') {
        onChange(selectedValue, option.label);
      }
    },
    [onChange],
  );

  const clearFilter = useCallback(() => {
    onClear(PriceRaiseListFilterKeys.status);
  }, [onClear]);

  return (
    <Select
      containerClassName="flex-1"
      className="w-full"
      label={t('Status')}
      placeholder={t('All')}
      bordered
      allowClear
      options={statusOptions}
      value={value}
      onChange={handleChange}
      onClear={clearFilter}
    />
  );
});
